import script from "./SensitiveTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./SensitiveTwo.vue?vue&type=script&setup=true&lang=js"

import "./SensitiveTwo.vue?vue&type=style&index=0&id=543084c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543084c8"]])

export default __exports__